import { SearchableTreeData } from './CommonTreeSelect';

export interface TreeCountAndChildren {
  count: string;
  children: SearchableTreeData[];
}

/**
 * This is a helper method, which is used to get nice looking count of children
 * which belong to particular parent after search, user to understand how many
 * items are hidden because of search.
 *
 * @param { SearchableTreeData[] } children - list of TreeData objects with search
 * field, which will be used for filtering items
 * @param { string } search - current user filtering input in TreeData component
 * @see { TreeData, TreeSelect, CommonTreeSelect } TreeData: 'antd/lib/tree-select'
 *
 * @return { count, children } where count is string which in filter case says
 * how many we filtered, how many we left, children - are our filtered values.
 */
export default (
  children: SearchableTreeData[],
  search?: string,
): TreeCountAndChildren => {
  if (search) {
    const filteredChildren = children.filter(({ search: s }) =>
      s.includes(search),
    );
    return {
      children: filteredChildren,
      count: `(${filteredChildren.length} of ${children.length})`,
    };
  } else {
    return {
      children,
      count: `(${children.length})`,
    };
  }
};
